import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useClassified } from "@/contexts/classified";
import { useMediumLink, useTrackingLinkClick } from "@/hooks";
export const FarbweltTeaser = ({ teaser, variant = "desktop", av_zone, }) => {
    var _a, _b, _c;
    const { image, linkTarget } = teaser || {};
    const { href, isExternal } = linkTarget || {};
    const { av_items } = (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.tracking) !== null && _b !== void 0 ? _b : {};
    const trackingData = {
        link_url: href !== null && href !== void 0 ? href : "",
        av_zone,
        outbound: !!isExternal,
        // @ts-ignore
        av_client_id: (_c = av_items[0]) === null || _c === void 0 ? void 0 : _c.client_id,
    };
    const mediumLink = useMediumLink(teaser === null || teaser === void 0 ? void 0 : teaser.type);
    const handleTrackingLinkClick = useTrackingLinkClick({
        event: "outlink",
        data: trackingData,
    });
    if (!teaser)
        return null;
    return (_jsx(Box, { as: "a", href: href, target: "_blank", display: "block", onClick: href
            ? () => {
                handleTrackingLinkClick();
            }
            : undefined, "data-tracking": href && !isExternal ? mediumLink : null, children: _jsx(Box, { as: "img", src: image === null || image === void 0 ? void 0 : image.src, alt: image === null || image === void 0 ? void 0 : image.alt, width: "100%", height: variant === "desktop" ? "250px" : "90px", objectFit: "contain" }) }));
};
